import React, { Component } from 'react'
import styles from './style.module.less'

// 结果页(loading状态)
export default class Loading extends Component {
  timer
  state = {
    time: 10
  }

  componentDidMount() {
    this.setTimer()
  }
  setTimer = () => {
    clearInterval(this.timer)
    this.countHandler()
    this.timer = setInterval(() => {
      this.countHandler()
    }, 1000)
  }
  countHandler = () => {
    if (this.state.time > 1) {
      this.setState({
        time: this.state.time - 1
      })
    } else {
      const { loadingEnd } = this.props
      loadingEnd()
      clearInterval(this.timer)
    }
  }
  render() {
    return (
      <div className={styles.load}>
        <div className={styles.loading} />
        <div className={styles.time}>{this.state.time}</div>
      </div>
    )
  }
}
